module.exports = __webpack_public_path__ + "e4f198da8d54f84a3cf2eed5099404ff.png";